<template>
  <div>
    <!-- 頭 -->
    <nav class="navbar navbar-expand-xl" v-if="HeadData">
      <div class="container">
        <div class="submenu">
          <template v-if="HeadData.RightTop_Menu">
            <a href="javascript:void(0)" :title="MenuData.Menu.Title" @click="goto(MenuData.Menu)"
              v-for="(MenuData, index) in HeadData.RightTop_Menu" :key="index">{{ MenuData.Menu.Title
              }}</a>
          </template>
          <div class="social_box">
            <a :href="HeadData.Facebook_Url" title="Facebook" v-if="HeadData.Facebook_Url" target="_blank">
              <img src="img/social_fb.svg" alt="">
            </a>
            <a :href="HeadData.IG_Url" title="IG" v-if="HeadData.IG_Url" target="_blank">
              <img src="img/social_ig.svg" alt="">
            </a>
            <a :href="HeadData.Twitter_Url" title="X" v-if="HeadData.Twitter_Url" target="_blank">
              <img src="img/social_twitter.svg" alt="">
            </a>
            <a :href="HeadData.Youtube_Url" title="Youtube" v-if="HeadData.Youtube_Url" target="_blank">
              <img src="img/social_youtube.svg" alt="">
            </a>
          </div>
          <a class="search" href="javascript:void(0)" title="" data-bs-toggle="modal" data-bs-target="#search_box">
            <img src="img/search_icon.svg" alt="">
          </a>
          <a class="language" href="javascript:void(0)" @click="changeLang('en')" v-if="local == 'zh_tw'">EN</a>
          <a class="language" href="javascript:void(0)" @click="changeLang('zh_tw')" v-if="local == 'en'">繁中</a>
        </div>
        <div class="logo_box">
          <router-link class="navbar-brand" to="/" :title="$t('首頁')">
            <h1><img src="img/logo_tw.png" alt="GCIT_logo"></h1>
          </router-link>
        </div>
        <div class="menu_box" v-if="HeadData && HeadData.Header_Menu">
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent"
            aria-expanded="false" aria-label="Toggle navigation">
            <span class="line1"></span>
            <span class="line2"></span>
            <span class="line3"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarToggleExternalContent">
            <ul class="navbar-nav menu">
              <!-- 第一層選單 a -->
              <li class="nav-item dropdown" v-for="MenuData in HeadData.Header_Menu">
                <template v-if="MenuData.SubMenus">
                  <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown" :title="MenuData.Menu.Title"
                    role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    {{ MenuData.Menu.Title }}
                  </a>
                  <!--第二層選單 a  -->
                  <div class="dropdown-menu nested-dropdown-menu" aria-labelledby="navbarDropdown"
                    v-if="MenuData.SubMenus">
                    <template v-for="SubMenuData in MenuData.SubMenus">
                      <template v-if="SubMenuData.SubMenus">
                        <a class="dropdown-item dropdown-toggle" href="javascript:void(0)" id="dropdown_third" role="button"
                          data-bs-toggle="dropdown" aria-expanded="false" :title="SubMenuData.Menu.Title">{{
                            SubMenuData.Menu.Title
                          }}</a>
                        <div class="dropdown-menu dropdown-submenu" aria-labelledby="dropdown_third">
                          <a class="dropdown-item" href="javascript:void(0)" :title="SubSubMenuData.Title"
                            v-for="SubSubMenuData in SubMenuData.SubMenus" @click="goto(SubSubMenuData)">{{ SubSubMenuData.Title }}</a>
                        </div>
                      </template>
                      <template v-else>
                        <a class="dropdown-item" href="javascript:void(0)" :title="SubMenuData.Menu.Title"
                          @click="goto(SubMenuData.Menu)">{{ SubMenuData.Menu.Title }}</a>
                      </template>
                    </template>
                  </div>
                </template>
                <template v-else>
                  <a class="nav-link" href="javascript:void(0)" @click="goto(MenuData.Menu)"
                    :title="MenuData.Menu.Title" role="button">
                    {{ MenuData.Menu.Title }}
                  </a>
                </template>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <!-- 搜尋 -->
    <div class="modal fade search_box" id="search_box" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="box">
            <p>搜尋</p>
            <input type="text" placeholder="關鍵字" v-model="Keyword">
            <button class="search_btn"><img src="img/search_icon.svg" alt="" @click="search()"></button>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="top_btn">
      <a href="javascript:void(0)" title="回頂端">
        <p>TOP</p>
      </a>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

//import { Fragment } from 'vue-fragment'

const messages = {
  zh_tw: {
  },
  en: {
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "HeadBlock",
  i18n,
  components: {
    //Fragment,
    Slick,
  },
  data() {
    return {
      HeadData: null,
      Keyword: "",
      local: "zh_tw",
    };
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/GCIT/Head",
        {
          params: {
            lang: $cookies.get("gcit_the_site_lang")
          },
        }
      )
      .then((response) => {
        this.HeadData = response.data;
        Promise.all(Array.from(document.images).map(img => {
          if (img.complete) return Promise.resolve();
          return new Promise(resolve => img.addEventListener('load', resolve));
        })).then(() => {
          setTimeout(() => {
            $("html body").scroll(function () {
              var N = $("html body").scrollTop();
              var windowHeight = $(window).height();
              var documentHeight = $(document).height();
              if (N > 400) {
                $('.top_btn').css('display', 'block');
                $('.admissions_btn').addClass('add');
              }
              else {
                $('.top_btn').css('display', 'none');
                $('.admissions_btn').removeClass('add');
              };
              if (N + windowHeight > documentHeight - 100) {
                $('.top_btn').addClass('bottom');
                $('.admissions_btn').addClass('bottom');
              }
              else {
                $('.top_btn').removeClass('bottom');
                $('.admissions_btn').removeClass('bottom');
              }
            });
            $(".top_btn a").click(function () {
              $('html,body').animate({ scrollTop: 0 }, 1000);
            });
            // 
            var navbarHeight = $(".navbar").height();
            $('.navbar-collapse').css('top', navbarHeight)
            $("html body").scroll(function () {
              var N = $("html body").scrollTop();
              var navbarHeight = $(".navbar").height();
              $('.navbar-collapse').css('top', navbarHeight)
              if (N > navbarHeight) {
                $('.navbar').addClass('add');
                $('.wrapper').css('padding-top', navbarHeight);
              }
              else {
                $('.navbar').removeClass('add');
                $('.wrapper').css('padding-top', 0);
              };
            });
            // 首頁 第三層選單 不重複出現
            $(".navbar .navbar-nav .dropdown-menu #dropdown_third").click(function () {
              if (!$(this).is('.add')) {
                $(".navbar .navbar-nav .dropdown-menu #dropdown_third").removeClass("add");
                $(this).addClass("add");
                $(this).siblings(".dropdown-submenu").hide();
                $(this).next(".dropdown-submenu").show();
              } else {
                $(".navbar .navbar-nav .dropdown-menu #dropdown_third").removeClass("add");
                $(this).siblings(".dropdown-submenu").hide();
              }
            });
            $(".navbar .navbar-nav .nav-item .nav-link").click(function () {
              $(this).parent("li").find(".dropdown-submenu").hide();
              $(".navbar .navbar-nav .dropdown-menu #dropdown_third").removeClass("add");
            });
            $(window).on('load', function () {
              $('.nested-dropdown-menu .dropdown-toggle').each(function () {
                $(this).on('click', function (event) {
                  event.stopPropagation();
                });
                $(this).on('hidden.bs.dropdown', function (event) {
                  const subDropdown = $(event.target).parent().find('.dropdown-submenu');
                  subDropdown.find('.show').each(function () {
                    $(this).removeClass('show');
                  });
                });
              });
            });
            $(document).ready(function () {
              var windowWidth = $(window).width();
              var marginLeft = parseInt($('.navbar .container').css('margin-left'));
              var paddingLeft = parseInt($('.navbar .container').css('padding-left'));
              var total = marginLeft + paddingLeft;
              if (windowWidth < 1199.98) {
                $('.navbar .menu .nav-item .nav-link').css('padding-left', total).css('padding-right', total);
                $('.navbar .navbar-nav .dropdown-menu .dropdown-item').css('padding-left', total + 20).css('padding-right', total + 20);
                $('.navbar .navbar-nav .dropdown-menu .dropdown-menu .dropdown-item').css('padding-left', total + 40).css('padding-right', total + 40);
                $('html body').append('<style>.navbar .navbar-nav .dropdown-menu .dropdown-item:hover:before{ width: calc( 100% - ' + total * 2 + 'px); left:' + total + 'px; }</style>');
              };
              if (windowWidth < 575.98) {
                $('.navbar .navbar-nav .dropdown-menu .dropdown-item').css('padding-left', total + 10).css('padding-right', total + 10);
                $('.navbar .navbar-nav .dropdown-menu .dropdown-menu .dropdown-item').css('padding-left', total + 20).css('padding-right', total + 20);
              };
            });
            $(".navbar-toggler").click(function () {
              $(this).toggleClass("add");
            });

          }, 0);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("gcit_the_site_lang")) {
      i18n.locale = $cookies.get("gcit_the_site_lang");
      this.local = $cookies.get("gcit_the_site_lang");
    } else {
      i18n.locale = $cookies.get("gcit_the_site_lang");
      this.local = "zh_tw";
    }
  },
  methods: {
    changeLang(lang) {
      $cookies.set("gcit_the_site_lang", lang, "30d");
      location.reload();
    },
    gotoCategoryByCId: function (CId) {
      this.$router.push({
        name: "Category",
        params: { CId: CId },
      });
    },
    gotoPostByPId: function (PId) {
      this.$router.push({
        name: "Post",
        params: { PId: PId },
      });
    },
    gotoUrl: function (Url, Blank) {
      if (Blank) {
        window.open(Url, "_blank");
      } else {
        location.href = Url;
      }
    },
    goto: function (MenuData) {
      if (MenuData.Type == 1) {
        this.gotoCategoryByCId(MenuData.CId);
      } else if (MenuData.Type == 2) {
        this.gotoPostByPId(MenuData.PId);
      } else if (MenuData.Type == 3) {
        this.gotoUrl(MenuData.Url, MenuData.Blank);
      }
    },
    search: function () {
      if (!this.Keyword) {
        let that = this;
        Swal.fire({
          title: that.$t("錯誤"),
          text: that.$t("請輸入關鍵字後再進行搜尋"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
          heightAuto: false,
        });
        return false;
      }
      $("#search_box").modal('toggle');
      this.$router.push({
        name: "Search",
        params: { Keyword: this.Keyword },
      });
    }
  },
};
</script>